import * as _ from 'underscore';
import { Subtract } from 'utility-types';

import { FilterUpdaterOwnProps, withFilterUpdater } from '../../app/spaces/helpers/FilterUpdater';
import { SortOrderUpdaterOwnProps, withSortOrderUpdater } from '../../app/spaces/helpers/SortOrderUpdater';
import { ConnectedFlowSpace } from './ConnectedFlowSpace';
import { FlowSpaceOwnProps } from './FlowSpace';
import {
  FlowSpaceDataFetcherProps,
  InjectedFlowSpaceDataFetcherProps,
  withFlowSpaceDataFetcher
} from './FlowSpaceDataFetcher';
import {
  FlowSpaceServiceInjectorProps,
  InjectedFlowSpaceServiceInjectorProps,
  withFlowSpaceServiceInjector
} from './FlowSpaceServiceInjector';

export type FlowSpaceProviderProps = FilterUpdaterOwnProps
  & SortOrderUpdaterOwnProps
  & FlowSpaceDataFetcherProps
  & FlowSpaceServiceInjectorProps
  & Subtract<Subtract<FlowSpaceOwnProps, InjectedFlowSpaceDataFetcherProps>, InjectedFlowSpaceServiceInjectorProps>;

export const FlowSpaceProvider: React.ComponentType<FlowSpaceProviderProps> = _.compose(
  withFilterUpdater,
  withSortOrderUpdater,
  withFlowSpaceDataFetcher,
  withFlowSpaceServiceInjector,
)(ConnectedFlowSpace);
